import { createBrowserHistory, createHashHistory } from 'history'

const customHistory = window.location.pathname.includes('index.html') ? createHashHistory() : createBrowserHistory()
export default customHistory
